module.exports = __webpack_public_path__ + "front/img/btn-bg.0ab13319.png";